import React, { PropsWithChildren, useContext } from 'react';
import { Link } from 'gatsby';
import { Button, Navbar, NavbarBrand } from 'reactstrap';
import { rootPath } from '../../routes';
import FlyoutMenu from './FlyoutMenu';
import { FaSearch } from 'react-icons/fa';
import { UserContext } from '../../context/UserContext';
import { isCapacitorBuild } from '../../utils/platform';
import LocalImage from '../common/images/LocalImage';

const TopNavbar = (props: PropsWithChildren) => {
  const { user } = useContext(UserContext);

  return (
    <>
      <Navbar
        color={'white'}
        expand="md"
        className={
          'position-relative py-0 px-3 d-flex w-100 flex-nowrap align-items-stretch'
        }
        style={{ height: '85px' }}
      >
        <NavbarBrand
          tag={Link}
          to={rootPath}
          className="h-100 me-0 d-flex align-items-center flex-shrink-0"
          style={{ width: '69px', height: '44px' }}
        >
          <LocalImage src="dentalpost-logo-on-light-bg.png" alt="DentalPost Logo" width={69} height={44} loading="eager" />
        </NavbarBrand>
        {!user && <FlyoutMenu />}
        <div className="d-flex gap-3 ms-auto me-lg-3">
          {!isCapacitorBuild && (
            <Button
              tag={Link}
              to="/dental-jobs/"
              color="transparent"
              className="ms-auto ms-sm-0 me-0 text-black d-flex justify-content-end align-items-center col-auto"
              aria-label="search dental jobs"
            >
              <FaSearch className="dp-font-lg" />
            </Button>
          )}
        </div>
        {props.children}
      </Navbar>
    </>
  );
};

export default TopNavbar;
